module.exports = __webpack_public_path__ + "russierenouvelables/img/renouvelables-explained.082eb200.webp";